function createIconComponent(src) {
  const iconSizes = {
    'xs': [ 10, 10 ],
    'sm': [ 12, 12 ],
    'md': [ 16, 16 ],
    '1x': [ 16, 16 ],
    'lg': [ 21, 21 ],
    '2x': [ 32, 32 ],
    '3x': [ 48, 48 ],
    '4x': [ 64, 64 ],
    '5x': [ 80, 80 ],
  };

  return {
    functional: true,
    props: {
      size: {
        type: String,
        default: '1x',
        validator: value => [ 'xs', 'sm', 'md', 'lg', 'xl', '2xl', '1x', '2x', '3x', '4x', '5x' ].includes(value),
      },
    },
    render(el, { props: { size } }) {
      const [ height, width ] = iconSizes[size] || [];
      return el('img', { domProps: { height, width, src } });
    },
  };
}

export const RewardsCoin = createIconComponent(require('@src/assets/coin.svg'));



// WEBPACK FOOTER //
// ./src/components/Icons.js